module.exports = __webpack_public_path__ + "static/media/10A.ccdfdecb.png";